import Switch from '@ui/switch';
import { FC } from 'react';
import styles from './setting-content.module.scss';
import SettingPreferredExplorer from './setting-preferred-explorer';
import SettingRpc from './setting-rpc';

const SettingContent: FC = () => {
  return (
    <div className={styles.setting}>
      <p className={styles.title}>Settings</p>
      <div className={styles.line}>
        <div>MEV Protect (Powered by Parrot)</div>
        <Switch />
      </div>
      <div className={styles.line}>
        <div>Animations</div>
        <Switch />
      </div>
      <div className={styles.line}>
        <div>Danmaku</div>
        <Switch />
      </div>
      <SettingPreferredExplorer />
      <SettingRpc />
    </div>
  );
};

export default SettingContent;
